import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import * as stylex from "@stylexjs/stylex";
import { queries, errorMessage, isUnauthorized } from "../lib/api";
import { styles } from "../lib/styles";
import { NavIcon, PageHeader } from "../components/Workspace";
import { RecordingPlayer } from "../components/RecordingPlayer";

export const Route = createFileRoute("/recordings/$recordingId")({ component: RecordingDetail });
function RecordingDetail() {
  const { recordingId } = Route.useParams();
  const me = useQuery(queries.me());
  const preview = useQuery({ ...queries.recording(recordingId), enabled: me.data?.admin === true });
  return (
    <>
      <Link to="/recordings" className="breadcrumb">
        <NavIcon name="ArrowLeft" /> Session recordings
      </Link>
      <PageHeader
        title={preview.data?.recording.alias ?? "Recording"}
        description={
          preview.data
            ? `${preview.data.recording.email} · ${new Date(preview.data.recording.created_at).toLocaleString()}`
            : "Recorded SSH output and session activity."
        }
      />
      {preview.isPending && (
        <p aria-busy="true" {...stylex.props(styles.notice)}>
          Loading recording…
        </p>
      )}
      {preview.error && (
        <div role="alert" {...stylex.props(styles.error)}>
          {errorMessage(preview.error)}
          {isUnauthorized(preview.error) && (
            <>
              {" "}
              <a href="/auth/login">Sign in again</a>
            </>
          )}
        </div>
      )}
      {preview.data && <RecordingPlayer preview={preview.data} />}
    </>
  );
}
